/**
 * @file
 * Methods for recording input events and console output and retrieving logs.
 */


const event = [];
const monitor = new Set();

let lconsole = new Set();
let lelement = new Set();
let lapp = new Set();
let sconsole = {};


export function add(el) {
    monitor.add(el);
    if ($telemetry.active) {
        addListener(el);
    }
}


export function remove(el) {
    monitor.delete(el);
    if ($telemetry.active) {
        removeListener(el);
    }
}


function elementEvent(e) {
    if (!e.__tmr) {
        e.__tmr = true;
        event.push({
            t: Date.now(),
            a: e.type,
            c: this.__tm.id
        });
    }
}


function addListener(el) {
    lelement.forEach(event => {
        el.addEventListener(event, elementEvent);
    });
}


function removeListener(el) {
    lelement.forEach(event => {
        el.removeEventListener(event, elementEvent);
    });
}


const $telemetry = {
    /** @member {boolean} - `true` if telemetry data is currently being recorded. */
    active: false,

    /**
     * Start recording telemetry data.
     * @param {Object} listen
     * @param {Array} listen.console - Array of console log levels to record; default is `['error']`.
     * @param {Array} listen.element - Array of element events to record; default is `['click']`.
     * @param {Array} listen.$app - Array of `$app` events to record; default is `['send','receive']`.
     */
    start(listen = {}) {
        if ($telemetry.active) {
            $telemetry.stop();
        }
        lconsole = new Set(listen.console || ['error']);
        lelement = new Set(listen.element || ['click']);
        lapp = new Set(listen.$app || ['send','receive']);
        lconsole.forEach(l => {
            sconsole[l] = console[l];
            console[l] = (...args) => {
                event.push({
                    t: Date.now(),
                    a: 'log',
                    l,
                    msg: args.join(' ')
                });
                sconsole[l].apply(console, args);
            };
        });
        monitor.forEach(addListener);
        event.length = 0;
        /** @ignore */
        $telemetry.active = true;
    },

    /** Stop recording telemetry data. */
    stop() {
        if ($telemetry.active) {
            /** @ignore */
            $telemetry.active = false;
            Object.assign(console, sconsole);
            sconsole = {};
            monitor.forEach(removeListener);
            lconsole.clear();
            lelement.clear();
        }
    },

    /** Clear the telemetry log. */
    clear() {
        event.length = 0;
    },

    /** Retrieve the telemetry log contents. */
    report() {
        return event;
    }
};


export default $telemetry;
